import { render, staticRenderFns } from "./SubcompanyList.vue?vue&type=template&id=32410af2&scoped=true&"
import script from "./SubcompanyList.vue?vue&type=script&lang=ts&"
export * from "./SubcompanyList.vue?vue&type=script&lang=ts&"
import style0 from "./SubcompanyList.vue?vue&type=style&index=0&id=32410af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32410af2",
  null
  
)

export default component.exports